/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDealerDetailsBio_seller = {
    readonly serviceId: string | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
        readonly aboutUsUnbranded: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
    readonly " $refType": "PdpSharedDealerDetailsBio_seller";
};
export type PdpSharedDealerDetailsBio_seller$data = PdpSharedDealerDetailsBio_seller;
export type PdpSharedDealerDetailsBio_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsBio_seller$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBio_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBio_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aboutUsUnbranded",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModalLazy_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '2201d83255054faff16ed69e5ec94493';
export default node;
